<template>

	<section class="image-text">

		<div v-if="!$mq.mobile" class="image" :style="{backgroundImage: 'url('+mainBackgroundImage+')'}">
		</div>
		<div class="text">
			<div class="content">
				<h4><slot name="subHeadline" /></h4>
				<h3><slot name="headline" /></h3>
				<div class="body">
					<slot name="body" />
				</div>
				<div class="cta">
					<slot name="cta" />
				</div>
			</div>
		</div>

	</section>

</template>

<script>

	export default {
		name: "ImageText",
		props: {
			mainBackgroundImage: String,
		}
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "container.scss";
	@import "responsive-font.scss";

	.image-text {
		display:flex;
		& > * {
			flex:1;
		}
		& + .image-text {
			flex-direction:row-reverse;
		}
	}

	.image {
		background-position:center; background-size:cover;
	}

	.text {
		display:flex; justify-content:center; align-items:left; flex-direction:column; padding:5rem 0; background:#F6F8F9;
		@include media(large) {
			padding:10rem 0;
		}
		.content {
			margin:0 auto; padding:0 5vw;
			@include media(large) {
				min-width:38rem; max-width:55rem; padding:0 1rem;
			}
		}
		h4 {
			@include responsive-font(20);
			line-height:1.2; font-weight:400; color:#FDB913; text-transform:uppercase; margin-bottom:.8rem;
		}
		h3 {
			@include responsive-font(40);
			line-height:1.25; font-weight:400; color:#3D3D3D; text-transform:uppercase; margin-bottom:3.2rem;
			@include media(small, large) {
				@include responsive-font(35);
			}
		}
		.body {
			color:#6D6E71; margin:1em 0;
		}
	}


</style>



// WEBPACK FOOTER //
// src/components/OurCompany/ImageText.vue